import { CardRoot } from "./card";
import { CardAction } from "./card-action";
import { CardContent } from "./card-content";
import { CardFooter } from "./card-footer";
import { CardDescription, CardHeader, CardTitle } from "./card-header";
import { CardImage } from "./card-image";

/**
 * Card — composable container molecule (DS-035).
 *
 * Compose real DS atoms directly inside `<Card.Action>` slots. A pressable
 * Card is one control, so its slots hold visuals (`<RadioIndicator>`,
 * `<Icon>`, `<Tag>`); interactive atoms (`<Checkbox>`, `<Stepper>`) go in a
 * non-pressable Card. Position is JSX-order driven — first `Card.Action` is
 * leading, last is trailing.
 *
 *   <Card
 *     direction="row"
 *     state={checked ? "selected" : "idle"}
 *     accessibilityRole="radio"
 *     checked={checked}
 *     onPress={...}
 *   >
 *     <Card.Action>
 *       <RadioIndicator checked={checked} size="sm" />
 *     </Card.Action>
 *     <Card.Header>
 *       <Card.Title>Premium plan</Card.Title>
 *       <Card.Description>$29/month · cancel anytime</Card.Description>
 *     </Card.Header>
 *     <Card.Action>
 *       <Icon name="CaretRight" size={16} />
 *     </Card.Action>
 *   </Card>
 */
export const Card = Object.assign(CardRoot, {
  Header: CardHeader,
  Title: CardTitle,
  Description: CardDescription,
  Action: CardAction,
  Image: CardImage,
  Content: CardContent,
  Footer: CardFooter,
});

export type {
  CardActionProps,
  CardContentProps,
  CardContextValue,
  CardDescriptionProps,
  CardDirection,
  CardFooterProps,
  CardGap,
  CardHeaderProps,
  CardImageProps,
  CardLayout,
  CardProps,
  CardRadius,
  CardShadow,
  CardState,
  CardTitleProps,
} from "./types";
